// フォームでエラーが発生した際に最初の入力フィールドにスクロールする
$(() => {

    let top = 0;

    $('.is-invalid').each((index, element) => {

        let newTop = $(element).parent().offset().top;

        if(top === 0 || top > newTop) {
            top = newTop;
        }
    });

    $('html, body').animate({
        scrollTop: top
    }, 'fast');
});

$(() => {
    $('.toggle-submit').on('click', function (event) {
        const toggleTarget = $(this).data('toggle-target');
        if ($(this).prop("checked")) {
            $(toggleTarget).prop("disabled", false);
        }  else {
            $(toggleTarget).prop("disabled", true);
        }
    });
})
